import { useEffect, useState } from 'react';

import {
  aplicarVersionPendiente,
  posponerVersion,
  suscribirAActualizacion,
} from './actualizacionDelServiceWorker.js';

/**
 * Aviso NO BLOQUEANTE de versión nueva en espera (RF-085, D-81, RN-131).
 *
 * No es un diálogo modal, no tapa el formulario y no impide seguir capturando: es
 * una cinta con dos salidas. "Después" deja la versión en espera y no recarga nada
 * (RN-130b); "Actualizar ahora" la aplica, y con captura en curso pide confirmar
 * porque la aplicación se recargará —lo escrito se conserva en el borrador de este
 * dispositivo y se restaura al volver (RN-144).
 *
 * Varias detecciones seguidas conservan una sola espera y un solo aviso: eso lo
 * resuelve el gestor, no esta cinta (RN-131, caso borde).
 */
export function CintaDeVersionNueva() {
  const [estado, setEstado] = useState({ hayVersionEnEspera: false, hayCapturaEnCurso: false });
  const [confirmando, setConfirmando] = useState(false);

  useEffect(() => suscribirAActualizacion(setEstado), []);

  if (!estado.hayVersionEnEspera) return null;

  if (confirmando) {
    return (
      <div className="aviso w" role="status" data-prueba="confirmar-actualizacion">
        <b>¿Actualizar ahora?</b> Tienes una captura en curso. Al actualizar, la aplicación se recarga;
        <b> lo que escribiste se conserva</b> en el borrador de este dispositivo y se restaurará al
        volver.
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <button
            className="btn"
            type="button"
            onClick={() => aplicarVersionPendiente({ forzar: true })}
            data-prueba="confirmar-actualizar-ahora"
          >
            Sí, actualizar ahora
          </button>
          <button className="btn sec" type="button" onClick={() => setConfirmando(false)}>
            Seguir capturando
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="aviso i" role="status" data-prueba="cinta-version-nueva">
      <b>Hay una versión nueva.</b> Se aplicará cuando termines lo que estás capturando.
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <button className="btn sec" type="button" onClick={posponerVersion} data-prueba="version-despues">
          Después
        </button>
        <button
          className="btn"
          type="button"
          data-prueba="version-actualizar-ahora"
          onClick={() => {
            if (estado.hayCapturaEnCurso) setConfirmando(true);
            else aplicarVersionPendiente();
          }}
        >
          Actualizar ahora
        </button>
      </div>
    </div>
  );
}
